import { apiv2_getPulses } from "@/app/api2"
import { useQuery } from "@tanstack/react-query"

export function usePulsesQuery() {
  return useQuery({
    queryKey: ["pulses"],
    queryFn: apiv2_getPulses,
    staleTime: Infinity, // force cache use
  })
}
